import { initial_fetch_all } from 'src/App';
import { setPersist, setSelectedHistory, setToastMessage } from 'src/store/my_pages/app';
import store, { dispatch } from 'src/store/Store';

export function setUserJobScheduleIdFromResData(apiResData: any) {
  const state: any = store.getState();
  const persist = state.appGeneralReducer.persist;

  if (Array.isArray(apiResData) && apiResData?.length > 0) {
    const newId = getInitialtUserJobScheduleId(apiResData);

    // Only call setInitialtUserJobScheduleId if there's an actual change in userJobScheduleId
    if (newId && newId !== persist.userJobScheduleId) {
      setInitialtUserJobScheduleId(newId);
    }
    return newId;
  } else {
    dispatch(setPersist({ key: 'userJobScheduleId', value: '' }));
    return '';
  }
}

export function getInitialtUserJobScheduleId(apiResData: any) {
  //? Use the `userJobScheduleId` from either localstorage or the first schedule scan result.
  const state: any = store.getState();
  const persist = state.appGeneralReducer.persist;
  const preSelectedScanNameLs = localStorage.getItem('selectedDomain');
  const preSelectedScan = persist?.schedule_scan?.find((i: any) => i.url === preSelectedScanNameLs);
  // if (preSelectedScan) return preSelectedScan?.id;

  if (!preSelectedScan?.lastWebsiteVulnerabilityId) {
    // dispatch(setToastMessage({ msg: 'The scan has not started yet. Please try again. 1', color: 'error', duration: 2000, autoClose: true }));
    // return;
  }
  if (preSelectedScan) {
    return preSelectedScan?.lastWebsiteVulnerabilityId;
  }

  const fallbackId = apiResData?.[0]?.lastWebsiteVulnerabilityId;
  return fallbackId;
}
export async function setInitialtUserJobScheduleId(newId) {
  // TODO: Birden fazla aynı domain eklendiyse scanId ve url lerde karışma olur lsler için

  if (!newId) {
    dispatch(setToastMessage({ msg: 'The scan has not started yet. Please try again', color: 'error', duration: 3000, autoClose: true }));
    return;
  }

  await dispatch(setPersist({ key: 'userJobScheduleId', value: newId }));
  await dispatch(setSelectedHistory(null));

  const state: any = store.getState();
  const persist = state.appGeneralReducer.persist;
  // const preSelectedScan = persist?.schedule_scan?.find((i: any) => i.id === newId);
  const preSelectedScan = persist?.schedule_scan?.find((i: any) => i.lastWebsiteVulnerabilityId === newId);
  await dispatch(setPersist({ key: 'active_domain_data', value: preSelectedScan }));
  if (preSelectedScan) localStorage.setItem('selectedDomain', preSelectedScan.url);
  // localStorage.setItem('selectedDomain', option.url);
  return true;
}

// export const getSidebarChipCounts(persist_name:string) {
// This is better to be coming from BE
// }